import { StatisticsCard } from '@juvare/common-web-ui/StatisticsCard';
import { Box } from '@mui/material';
import React from 'react';
export const AnalyticsCard = (props) => {
    return (React.createElement(Box, { sx: {
            flex: {
                xs: '1 100%',
                sm: '1 calc(50% - 8px)',
                lg: '1 auto',
            },
        } },
        React.createElement(StatisticsCard, Object.assign({}, props))));
};
